import { orderByValues } from '@/metrics/hooks/useFilters/constants'

export const aggregatedSentiments = {
  positive: 'positive',
  neutral: 'neutral',
  negative: 'negative',
}

export const unknownReasonKey = 'unknown'

export const subReasonsFilters = {
  ordering: `-${orderByValues.count}`,
}
